import { FC, useState, memo } from 'react';

import { ModalProps, ModalTypes } from 'application/providers/ModalProvider';
import { useAccountCompanyCountry } from 'application/hooks';

import { Country, RequestDeviceType } from 'domain/api/graphql/generated';

import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';
import Radio from '@zvuk-b2b/react-uikit/ui/Radio';

import { TEXTS } from './texts';
import { useOnboardingContext } from '../../useOnboardingContext';
import { useOnboardingActionContext } from '../../useOnboardingActionContext';
import { FLOWS_FOR_NOT_SHOW_STOP_ONBOARDING_WARNING } from '../../consts';

import styles from './index.module.scss';

enum VideoPlayer {
  ANDROID_TV = 'ANDROID_TV',
  OTHER = 'OTHER',
}

const ChooseVideoPlayerModal: FC<ModalProps[ModalTypes.CHOOSE_VIDEO_PLAYER]> = ({ close, replaceModal, openModal }) => {
  const currentCompanyCountry = useAccountCompanyCountry();
  const { flowType } = useOnboardingContext();
  const { clearCurrentPoint } = useOnboardingActionContext();

  const [videoPlayer, setVideoPlayer] = useState<VideoPlayer>(VideoPlayer.ANDROID_TV);

  const handleNext = () => {
    switch (videoPlayer) {
      case VideoPlayer.OTHER: {
        replaceModal(ModalTypes.SBERBUSSINESS_REQUEST, {
          requestType: RequestDeviceType.Video,
        });
        break;
      }
      case VideoPlayer.ANDROID_TV: {
        replaceModal(ModalTypes.DOWNLOAD_TV_APP, {});
        break;
      }

      default: {
        replaceModal(ModalTypes.DOWNLOAD_TV_APP, {});
      }
    }
  };

  const handleCancel = () => {
    if (flowType && FLOWS_FOR_NOT_SHOW_STOP_ONBOARDING_WARNING.has(flowType)) {
      close();
      clearCurrentPoint();
      return;
    }

    openModal(ModalTypes.STREAM_STOP_BINDING_FLOW_WARNING, {});
  };

  const handleBack = () => {
    replaceModal(ModalTypes.SELECT_PLAYER_MODAL, {});
  };

  return (
    <ModalScreen
      onClose={handleCancel}
      title={TEXTS.MODAL_TITLE}
      actionButtons={[
        <Button
          key="choose_video_player_modal_next"
          elementId="choose_video_player_modal_next"
          type={ButtonType.PRIMARY}
          onClick={handleNext}>
          {TEXTS.NEXT}
        </Button>,
        <Button
          key="choose_video_player_modal_back"
          elementId="choose_video_player_modal_back"
          type={ButtonType.SECONDARY}
          onClick={handleBack}>
          {TEXTS.BACK}
        </Button>,
      ]}>
      <div className={styles.ChooseVideoModalContent}>{TEXTS.MODAL_CONTENT}</div>

      <Radio
        className={styles.ChooseVideoModalRadio}
        isChecked={videoPlayer === VideoPlayer.ANDROID_TV}
        onChange={(value) => value && setVideoPlayer(VideoPlayer.ANDROID_TV)}
        elementId="radio_video_player_modal_tv"
        key={VideoPlayer.ANDROID_TV}>
        {TEXTS.ANDROID_TV}
      </Radio>

      {currentCompanyCountry !== Country.Kz && (
        <Radio
          isChecked={videoPlayer === VideoPlayer.OTHER}
          className={styles.ChooseVideoModalRadio}
          onChange={(value) => value && setVideoPlayer(VideoPlayer.OTHER)}
          elementId="radio_video_player_modal_other"
          key={VideoPlayer.OTHER}>
          {TEXTS.OTHER}
        </Radio>
      )}
    </ModalScreen>
  );
};

export default memo(ChooseVideoPlayerModal);
